/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'fromNowOrDateTime',
    standalone: false
})
export class FromNowOrDateTimePipe implements PipeTransform {

  private readonly FROM_NOW_FORMATTING_THRESHOLD_DAYS = 31;
  private readonly CUSTOM_THRESHOLD_ARGS_POSITION = 0;
  private readonly DATE_FORMAT_AFTER_THRESHOLD_DAYS = 'MM/DD/YYYY [at] hh:mm A';

  /**
   * @param date
   * @param args if custom threshold is set - it will be used, otherwise default value from FROM_NOW_FORMATTING_THRESHOLD_DAYS is used.
   */
  transform(date: string | number, ...args: any[]): string {
    const now = moment();
    if (now.diff(moment(date), 'days') < this.calculateThresholdDays(args)) {
      return moment(date).fromNow();
    } else {
      return moment(date).format(this.DATE_FORMAT_AFTER_THRESHOLD_DAYS);
    }
  }

  private calculateThresholdDays(args: any[]): number {
    const customThreshold = args[this.CUSTOM_THRESHOLD_ARGS_POSITION]
    if(customThreshold){
      return +customThreshold;
    }
    return this.FROM_NOW_FORMATTING_THRESHOLD_DAYS;
  }

}
